import { render, staticRenderFns } from "./BudgetLineHistoryModal.vue?vue&type=template&id=488050d8"
import script from "./BudgetLineHistoryModal.vue?vue&type=script&lang=js"
export * from "./BudgetLineHistoryModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports